/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const prevSocket = (currentSocket - 1).toString();
    const X_AXIS_NAME = feature.getSettingValue('X_AXIS_NAME');
    const Y_AXIS_NAME = feature.getSettingValue('Y_AXIS_NAME');
    const Z_AXIS_NAME = feature.getSettingValue('Z_AXIS_NAME');
    const NAME = `${X_AXIS_NAME}_${Y_AXIS_NAME}_${Z_AXIS_NAME}`;
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: `var_${X_AXIS_NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${X_AXIS_NAME}_update_completed(simulator.context['${ID}']['X_AXIS_NAME'])`,
    });

    blocks.push({
        location: `var_${Y_AXIS_NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${Y_AXIS_NAME}_update_completed(simulator.context['${ID}']['Y_AXIS_NAME'])`,
    });

    blocks.push({
        location: `var_${Z_AXIS_NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${Z_AXIS_NAME}_update_completed(simulator.context['${ID}']['Z_AXIS_NAME'])`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext('${ID}', {
    'X_AXIS_NAME': ${X_AXIS_NAME},
    'Y_AXIS_NAME': ${Y_AXIS_NAME},
    'Z_AXIS_NAME': ${Z_AXIS_NAME}
});
        `,
    });

    return blocks;
};
